export default __webpack_public_path__ + "static/media/customer_2.bb438347.png";